import apiWrapper from 'Helpers/apiWrapper'
import extractApiData from 'Helpers/extractApiData'
import { encodeParams } from 'mailup-react-helpers'

const endpoints = (baseURL => {
  return {
    getListOfSources: ({ filterSourceIds, ...params }) =>
      `${baseURL}/api/sources?${encodeParams(params)}${filterSourceIds
        .map(id => `&filterSourceIds=${id}`)
        .join('')}`,
    getListOfStatus: (IdSource, params) =>
      `${baseURL}/api/sources/${IdSource}/status?${encodeParams(params)}`
  }
})(process.env.CONTENTS_SOURCE_URL)

/**
 * @typedef {Object} SourceResponse
 * @property {number} Id
 * @property {string} SourceName
 * @property {boolean} IsEnabled
 * @property {string} Guid
 *
 * @typedef {Object} PagedList
 * @property {Array<SourceResponse>} items
 * @property {number} pageCount
 * @property {number} pageNumber
 * @property {number} pageSize
 * @property {number} totalItems
 *
 */

/**
 * @description List of all sources available
 * @param {Object} params
 * @param {Array<number>} params.filterSourceIds List of sources id
 * @param {number} params.pageSize Number of sources returned
 * @param {number} params.pageNumber Page number
 * @param {string} params.orderBy Order by specified field
 * @param {boolean} params.orderDescending Order descending
 * @returns {PagedList} Returns a list containing all sources. The list supports paging. If no parameters passed, it returns alle the sources.
 *
 */
export const contentsSourceApiGetListOfSources = params => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getListOfSources(params)
  }).then(extractApiData)
}

/**
 * @typedef {Object} SourceStatus
 * @property {number} Status 1 = OK, 2 = KO
 * @property {string} UpdateDate
 *
 * @typedef {Object} StatusPagedList
 * @property {Array<SourceStatus>} items
 * @property {number} pageCount
 * @property {number} pageNumber
 * @property {number} pageSize
 * @property {number} totalItems
 *
 */

/**
 * @description List of all history available for an id source
 * @param {number} IdSource ID of source which status have to be returned
 * @param {Object} params
 * @param {number} params.pageSize Number of sources returned
 * @param {number} params.pageNumber Page number
 * @returns {StatusPagedList} Returns a list containing all status. The list supports paging. If no parameters passed, it returns alle the sources.
 */
export const contentsSourceApiGetListOfStatus = (IdSource, params) => {
  return apiWrapper({
    method: 'get',
    url: endpoints.getListOfStatus(IdSource, params)
  }).then(extractApiData)
}
